import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import ApiService from "@/core/services/ApiService";

export interface Error {
  status: boolean;
  message: string;
}

export interface Questions {
  errors: Error;
}

@Module
export default class QuestionsModule extends VuexModule implements Questions {
  errors = {} as Error;
  ticket = [];
  tickets = [];
  departments = [];
  department = [];
  /**
   * Get current question object
   * @returns question
   */

  /**
   * Get list of questions object
   * @returns questions
   */
  get currentTickets() {
    return this.tickets;
  }

  get currentTicket() {
    return this.ticket;
  }

  get currentDepartments() {
    return this.departments;
  }

  /**
   * Get questions errors
   * @returns array
   */
  get getTicketErrors() {
    if (JSON.stringify(this.errors) === "{}") {
      this.errors.status = true;
      this.errors.message = "";
    }
    return this.errors;
  }

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors.status = error.status;
    this.errors.message = error.message;
    if (typeof error.errors !== "undefined") {
      let txt = "";
      const size = Object.keys(error.errors).length;
      if (size > 0) {
        Object.keys(error.errors).forEach(function (key) {
          txt += error.errors[key] + "<br />";
        });
        this.errors.message = txt;
      }
    }
  }

  @Mutation
  [Mutations.SET_TICKETS](tickets) {
    this.tickets = tickets;
  }

  @Mutation
  [Mutations.SET_TICKET](ticket) {
    this.ticket = ticket.data;
  }

  @Mutation
  [Mutations.SET_DEPARTMENTS](departments) {
    this.departments = departments;
  }

  @Action
  [Actions.GET_TICKETS](credentials) {
    return ApiService.get("admin/ticket/all", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_TICKETS, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.CLOSE_TICKET](credentials) {
    return ApiService.get("ticket/close", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.ANSWER](credentials) {
    return ApiService.post("ticket/answer", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.GET_TICKET](credentials) {
    return ApiService.get("ticket/show", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_TICKET, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.GET_DEPARTMENTS](credentials) {
    return ApiService.get("admin/ticket-department", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_DEPARTMENTS, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.DOWNLOAD_ATTACHMENT](payload) {
    const { ticketId, fileName } = payload;
    return ApiService.get(`ticket/download-attachments/${ticketId}/${fileName}`, "", { responseType: 'blob' })
      .then((response) => {

        const url = window.URL.createObjectURL(new Blob([response.data]))

        const link = document.createElement('a')

        link.href = url
        let file_name = 'invoice.jpeg';
        if(response.headers['content-type'] === 'image/png') file_name = 'invoice.png';
        if(response.headers['content-type'] === 'image/jpg') file_name = 'invoice.jpg';
        if(response.headers['content-type'] === 'application/pdf') file_name = 'invoice.pdf';

        link.setAttribute('download', file_name)

        document.body.appendChild(link)

        link.click()

        link.remove()

      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.EDIT_DEPARTMENT](credentials) {
    return ApiService.put("admin/ticket-department/" + credentials.id, credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.ADD_DEPARTMENT](credentials) {
    return ApiService.post("admin/ticket-department", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }
}
